var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRedCross = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ep:circle-close-filled")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account---Cancel-My-Subscriptions",
    transform: "translate(-367.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ep:circle-close-filled",
    transform: "translate(367.000000, 387.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5 C17.7989899,1.5 22.5,6.20101013 22.5,12 C22.5,17.7989899 17.7989899,22.5 12,22.5 C6.20101013,22.5 1.5,17.7989899 1.5,12 C1.5,6.20101013 6.20101013,1.5 12,1.5 Z M12,10.7265 L9.561,8.2875 C9.33351114,8.06001113 9.00193889,7.97116661 8.69118332,8.05443331 C8.38042775,8.13770002 8.13770002,8.38042775 8.05443331,8.69118332 C7.97116661,9.00193889 8.06001113,9.33351114 8.2875,9.561 L10.7265,12 L8.2875,14.439 C8.06001114,14.6664889 7.97116662,14.9980611 8.05443332,15.3088167 C8.13770003,15.6195722 8.38042776,15.8623 8.69118332,15.9455667 C9.00193889,16.0288334 9.33351114,15.9399889 9.561,15.7125 L12,13.2735 L14.439,15.7125 C14.6664889,15.9399889 14.9980611,16.0288334 15.3088167,15.9455667 C15.6195722,15.8623 15.8623,15.6195722 15.9455667,15.3088167 C16.0288334,14.9980611 15.9399889,14.6664889 15.7125,14.439 L13.2735,12 L15.7125,9.561 C15.9399889,9.33351114 16.0288334,9.00193889 15.9455667,8.69118332 C15.8623,8.38042775 15.6195723,8.13770002 15.3088167,8.05443331 C14.9980611,7.97116661 14.6664889,8.06001113 14.439,8.2875 L12,10.7265 Z",
    id: "Shape",
    fill: "#FF5C5C",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redCross.e05a9286.svg";
export { ForwardRef as ReactComponent };